export default "__VITE_ASSET__BZmiE7sb__";